<template>
  <InfoTooltip :position="position">
    <template v-slot:trigger>
      <slot name="trigger">
        <i class="pi pi-info-circle" style="font-size: 1.2rem; cursor: pointer; color: #0D3D52;"></i>
      </slot>
    </template>
    
    <div class="agility-rating-tooltip">
      <h3 class="tooltip-title">{{ title }}</h3>
      
      <div class="rating-legend">
        <div v-for="(rating, key) in ratingEntries" :key="key" class="rating-item">
          <div class="rating-color-sample"
          :class="getRatingInfo(rating.min).colors.bg"
         ></div>
          <div class="rating-details">
            <div class="rating-range">
              <strong>{{ getRatingInfo(rating.min).name }}</strong> ({{ rating.min }}-{{ rating.max }})
            </div>
            <div class="rating-description">{{ getRatingInfo(rating.min).description }}</div>
          </div>
        </div>
      </div>
    </div>
  </InfoTooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import InfoTooltip from './InfoTooltip.vue';
import agilityRatings from '@/utils/agilityRatings';

export default defineComponent({
  name: 'AgilityRatingTooltip',
  components: {
    InfoTooltip
  },
  props: {
    title: {
      type: String,
      default: 'Agility Rating Scale'
    },
    position: {
      type: String,
      default: 'bottom'
    }
  },
  setup() {
    // Get the ratings and descriptions from the imported module
    const ratingEntries = agilityRatings.RATINGS;
    const descriptions = agilityRatings.DESCRIPTIONS;
    const getRatingInfo = agilityRatings.getRatingInfo;
    
    // Helper to convert Tailwind classes to hex colors for styling
    const getHexColor = (rating: string) => {
      const colorMap: Record<string, string> = {
        'HIGH': '#82ca74',      // Green
        'MODERATE': '#ffd966',  // Yellow
        'LOW': '#f8a154',       // Orange
        'CRITICAL': '#e04f5f'   // Red
      };
      
      return colorMap[rating] || '#cccccc';
    };

    return {
      ratingEntries,
      descriptions,
      getHexColor,
      getRatingInfo
    };
  }
});
</script>

<style scoped>
.agility-rating-tooltip {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.tooltip-title {
  font-size: 14px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}

.rating-legend {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rating-item {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.rating-color-sample {
  width: 8px;
  border-radius: 4px;
  flex-shrink: 0;
  align-self: stretch;
}

.rating-details {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  flex-grow: 1;
}

.rating-range {
  font-weight: 500;
  margin-bottom: 2px;
}

.rating-description {
  color: #555;
  line-height: 1.4;
}
</style> 